import React, { useEffect } from 'react';
import HeroSection from '../components/Landing/HeroSection';
import StatsSection from '../components/Landing/StatsSection';
import LeaseStepsSection from '../components/Landing/LeaseStepsSection';
import OptionalStepsSection from '../components/Landing/OptionalStepsSection';
import ComplianceSection from '../components/Landing/ComplianceSection';
import TestimonialsSection from '../components/Landing/TestimonialsSection';
import CTASection from '../components/Landing/CTASection';
import SEOHelmet from '../components/shared/SEOHelmet';
import FAQSection from '../components/Landing/FAQSection';

const LandingPage: React.FC = () => {
  useEffect(() => {
    // Apply Coinbase design system colors
    document.body.style.background = '#ffffff';
    document.body.style.color = '#111111';
    document.body.style.fontFamily = "'Graphik', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif";
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.body.style.background = '';
      document.body.style.color = '';
      document.body.style.fontFamily = '';
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <div style={{ 
      minHeight: '100vh',
      background: '#ffffff',
      fontFamily: "'Graphik', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
      overflowX: 'hidden',
      position: 'relative'
    }}>
      <SEOHelmet pageType="landing" />
      <HeroSection />
      <StatsSection />
      <LeaseStepsSection />
      <ComplianceSection />
      <OptionalStepsSection />
      {/* <ComparisonTableSection /> */}
      <FAQSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
};

export default LandingPage; 
